module.exports = __webpack_public_path__ + "static/img/2_1_2_2.d4d2fc41.jpg";